import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { timeModel } from '~/models';
import styles from './DigitalSignature.module.scss';
function SignatureDisplay(param) {
    let { formattedDigitalSignature, compact } = param;
    var _approvalSignature_svg, _approvalSignature_text;
    const { approvalSignature, signature } = formattedDigitalSignature;
    if ((approvalSignature === null || approvalSignature === void 0 ? void 0 : approvalSignature.type) === 'svg' && ((_approvalSignature_svg = approvalSignature.svg) === null || _approvalSignature_svg === void 0 ? void 0 : _approvalSignature_svg.content)) {
        return /*#__PURE__*/ _jsx("div", {
            className: compact ? styles.svgSignatureCompact : styles.svgSignature,
            "data-testid": "digital-signature-block-signature",
            dangerouslySetInnerHTML: {
                __html: approvalSignature.svg.content
            }
        });
    }
    return /*#__PURE__*/ _jsx("span", {
        className: styles.signedSignature,
        "data-testid": "digital-signature-block-signature",
        children: (approvalSignature === null || approvalSignature === void 0 ? void 0 : approvalSignature.type) === 'text' && ((_approvalSignature_text = approvalSignature.text) === null || _approvalSignature_text === void 0 ? void 0 : _approvalSignature_text.value) ? approvalSignature.text.value : signature
    });
}
function DigitalSignatureLegacy(param) {
    let { formattedDigitalSignature } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.digitalSignature,
        "data-testid": "digital-signature-block",
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.detailsWrapper,
            children: /*#__PURE__*/ _jsxs(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                testId: "digital-signature-block-when",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.signedSignature,
                        "data-testid": "digital-signature-block-signature",
                        children: formattedDigitalSignature.signature
                    }),
                    ' ',
                    formattedDigitalSignature.on,
                    " ",
                    formattedDigitalSignature.ip
                ]
            })
        })
    });
}
function DigitalSignatureNew(param) {
    let { formattedDigitalSignature } = param;
    const dateFormatted = "".concat(timeModel.formatDateWithTimeShortMonth(formattedDigitalSignature.timestamp, true), " ").concat(formattedDigitalSignature.ip);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.digitalSignature,
        "data-testid": "digital-signature-block",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.detailsWrapper,
            children: [
                /*#__PURE__*/ _jsx(SignatureDisplay, {
                    formattedDigitalSignature: formattedDigitalSignature,
                    compact: true
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "secondary",
                    testId: "digital-signature-block-when",
                    children: formattedDigitalSignature.signature
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "secondary",
                    testId: "digital-signature-block-date",
                    children: dateFormatted
                })
            ]
        })
    });
}
function DigitalSignature(param) {
    let { formattedDigitalSignature } = param;
    const { CLIENT_ONBOARDING_NEW_FLOW } = useFeatureFlags();
    return CLIENT_ONBOARDING_NEW_FLOW ? /*#__PURE__*/ _jsx(DigitalSignatureNew, {
        formattedDigitalSignature: formattedDigitalSignature
    }) : /*#__PURE__*/ _jsx(DigitalSignatureLegacy, {
        formattedDigitalSignature: formattedDigitalSignature
    });
}
export default DigitalSignature;
export { DigitalSignatureLegacy, DigitalSignatureNew };
